export default __webpack_public_path__ + "static/RahulJuware-f8707735c1d0ba4bfb38d53c94b3cc96.png";